import { GridColumns } from "@mui/x-data-grid";
import React from "react";
import { FormField } from "../../../reusable-components/Table/AddEditItem/interfaces";
import { useTranslation } from "react-i18next";
import { AlertLineReportStatusDTO } from "../../../models/alert-line-report-status/alert-line-report-status-dto";
import { AlertLineReportStatusSTO } from "../../../models/alert-line-report-status/alert-line-report-status-sto";

import Table from "../../../reusable-components/Table/Table";
import { AlertLineReportStatusApiService } from "../../../services/alert-line/alert-line-report-status-api.service";
import { FT_ALRS } from "../../../utils/constants/filter-tables-constants";

const AlertLineReportStatusTable = () => {
  const tRP = "pages.system_settings.tables.alert_line_report_status";
  const { t } = useTranslation();

  const formFields: FormField[] = [
    {
      field: "name",
      labelKey: t(`common_words.name`),
    },
    {
      field: "code",
      labelKey: t(`common_words.code`),
    },
    {
      field: "description",
      labelKey: t(`common_words.description`),
    },
  ];

  const columns: GridColumns<AlertLineReportStatusDTO> = [
    {
      field: "name",
      headerName: t(`common_words.name`),
      headerAlign: "center",
      disableColumnMenu: true,
      flex: 1,
    },
    {
      field: "code",
      headerName: t(`common_words.code`),
      headerAlign: "center",
      disableColumnMenu: true,
      flex: 1,
    },
    {
      field: "description",
      headerName: t(`common_words.description`),
      headerAlign: "center",
      disableColumnMenu: true,
      flex: 1,
    },
  ];

  const DEFAULT_ITEM: AlertLineReportStatusSTO = {
    id: "",
    isDeleted: false,
    name: "",
    code: "",
    description: "",
  };

  return (
    <>
      <Table
        filter={FT_ALRS}
        translationRootPath={tRP}
        columns={columns}
        defaultItem={DEFAULT_ITEM}
        formFields={formFields}
        serviceApi={new AlertLineReportStatusApiService()}
      />
    </>
  );
};
export default AlertLineReportStatusTable;
